import { Construction } from 'lucide-react';
import { Card } from '../shared/ui/Card.js';
import { PageHeader } from '../shared/layout/PageHeader.js';
import './placeholder.css';

/** Screens defined in the spec but outside this first slice. */
export function PlaceholderPage({ title, description }: { title: string; description: string }) {
  return (
    <>
      <PageHeader title={title} description={description} />
      <Card>
        <div className="placeholder">
          <Construction size={22} strokeWidth={1.6} />
          <p>Cet écran est spécifié et sera construit dans une prochaine itération.</p>
        </div>
      </Card>
    </>
  );
}
